import InfoOutlined from '@mui/icons-material/InfoOutlined';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

export interface InfoIconButtonProps extends Omit<IconButtonProps, 'children'> {
  tooltip: string;
  tooltipProps?: Partial<React.ComponentProps<typeof Tooltip>>;
}

export const InfoIconButton = ({ tooltip, tooltipProps, ...iconButtonProps }: InfoIconButtonProps) => {
  return (
    <Tooltip title={tooltip} placement="top" {...tooltipProps}>
      <IconButton color="default" {...iconButtonProps}>
        <InfoOutlined />
      </IconButton>
    </Tooltip>
  );
};
